/**
 * Updates window.utag_data.
 * When we update the cart through AJAX (remove item, update quantity) we need to update the utag_data on the frontend.
 * @param {String|JSON} newData JSON string returned in the API response containing the new utag_data
 */
function updateUtagData (newData) {

	window.utag_data = typeof newData === 'string' || newData instanceof String ? JSON.parse(newData) : newData;
	window.utag_data.list_type = sessionStorage.getItem('listType');
	window.utag_data.product_impression_position = [ sessionStorage.getItem('sortPosition') ];
	window.utag_data.resolution_height = window.screen.height;
	window.utag_data.resolution_width = window.screen.width;

}

export default updateUtagData;
